import 'swiper/scss';
import 'swiper/scss/pagination';
import React from "react";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Pagination} from "swiper";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import {toExternalUrl} from '../../../utils/utils'
import IconContainer from "../IconContainer";
import * as carrouselStyles from "../../../styles/carrousels/carrousel.module.scss";
import {altNN} from "../../../utils/parsing";

SwiperCore.use([Pagination]);

const DiaporamaCarrousel = ({items}) => {
    const {t} = useTranslation();
    const paginationRef = React.useRef(null);
    const [swiper, setSwiper] = React.useState(null);
    const filteredItems = items.filter((item) => (item.media?.imageFile))
    const [display, setDisplay] = React.useState(false);

    React.useEffect(() => {
        setDisplay(true)
    }, [])

    return (<div
        className={carrouselStyles.rootDiaporamaCarrousel}
        role="group"
        aria-roledescription="carrousel"
        aria-label={items?.aria_label}
    >
        {display && <button
            className={carrouselStyles.leftArrowDiaporamaTest}
            tabIndex="0"
            onKeyDown={(e) => {
                e.currentTarget.click()
            }}
            onClick={() => {
                swiper.slidePrev()
            }}
            aria-label={t("carrousel.leftArrow")}
        >
            <IconContainer
                icon="ARROW_LEFT_LARGE"
                color="WHITE"
                variant="contained"
                size="40"
            />
        </button>}
        {display && <button
            className={carrouselStyles.rightArrowDiaporamaTest}
            tabIndex="0"
            onKeyDown={(e) => {
                e.currentTarget.click()
            }}
            onClick={() => {
                swiper.slideNext()
            }}
            aria-label={t("carrousel.rightArrow")}
        >
            <IconContainer
                icon="ARROW_RIGHT_LARGE"
                color="WHITE"
                variant="contained"
                size="40"
            />
        </button>}
        <div className={carrouselStyles.relative} style={{width: "100%"}}>
            <div className={carrouselStyles.bloc_diaporama}>
                <div className={carrouselStyles.innerBloc}>
                    <Swiper
                        pagination={{
                            el: paginationRef.current,
                            clickable: true,
                            bulletElement: 'li',
                            bulletClass: carrouselStyles.thumbnails,
                            bulletActiveClass: carrouselStyles.thumbnailsActive,
                        }}
                        centeredSlides={true}
                        speed={600}
                        loop
                        spaceBetween={0}
                        slidesPerView={1}
                        onSwiper={(core) => setSwiper(core)}
                        style={{width: "100%", height: "100%"}}
                        className={clsx({[carrouselStyles.inLoadDiaporama]: !display})}
                    >
                        {filteredItems?.map((item, index) => (
                                <SwiperSlide
                                    role="tabpanel"
                                    id={"panel-" + index}
                                    aria-labelledby={"tab-" + index}
                                    aria-roledescription="diapo"
                                    aria-label={item.aria_label}
                                    key={'slide' + index}
                                    style={{height: '100%'}}
                                >
                                    <GatsbyImage
                                        key={item.id}
                                        loading="eager"
                                        image={getImage(item.media?.imageFile)}
                                        alt={altNN("")}
                                        title={item.media?.name || ""}
                                        style={{height: "100%", width: "100%"}}
                                    ></GatsbyImage>
                                    <div
                                        style={{
                                            height: "inherit",
                                            width: "-webkit-fill-available",
                                            position: "absolute",
                                            zIndex: 1,
                                            top: 0,
                                        }}
                                    >
                                        <div
                                            className={carrouselStyles.titleContent}
                                        >
                                            {item.title && item.link ? (<a
                                                href={toExternalUrl(item.link)}
                                                name={item.title}
                                                target={item.newWindow ? "_blank" : "_self"}
                                                style={{
                                                    textDecoration: 'none', cursor: "pointer",
                                                }}
                                                className={carrouselStyles.marginCarrouselTitle}
                                                rel="noreferrer"
                                            >
                                                <h3
                                                    className={clsx(carrouselStyles.text_color, carrouselStyles.colorsDiapo, carrouselStyles.padding, carrouselStyles.h3Reponsive)}
                                                >
                                                    {item.title}
                                                </h3>
                                            </a>) : (<div
                                                className={carrouselStyles.marginCarrouselTitle}
                                            >
                                                <h3
                                                    className={clsx(carrouselStyles.text_color, carrouselStyles.colorsDiapo, carrouselStyles.padding, carrouselStyles.h3Reponsive)}
                                                >
                                                    {item.title}
                                                </h3>
                                            </div>)}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        )}
                    </Swiper>
                </div>
            </div>
        </div>
        <div className={carrouselStyles.thumbnailMargin}>
            <ul
                ref={paginationRef}
                aria-label={t("carrousel.chips")}
                style={{display: "flex"}}
            >
            </ul>
        </div>
    </div>);
};

export default DiaporamaCarrousel;
